import { Injectable } from '@angular/core';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InternalServerErrorModalComponent } from '../../app/modals/internal-server-error-modal/internal-server-error-modal.component';
import { DataLostWarningModalComponent } from '../modals/data-lost-warning-modal/data-lost-warning-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  constructor(config: NgbModalConfig, private modalService : NgbModal) { }

  openModal(modalView, isKeyboard: boolean = true, backdropClass: string = '', isBackdrop ?: boolean | 'static', customWindowClass: string = '', size: string = "", _centered= true) {
    
    let  modalReference = this.modalService.open(modalView, { centered: _centered, keyboard: isKeyboard, backdropClass: backdropClass, backdrop: isBackdrop, windowClass: customWindowClass, size: size });

    modalReference.result.then((result) => {
      console.log(result);
    }, (reason) => {
      console.log(reason);
      this.modalService.dismissAll();
    });
  }

  hasOpenModals() {
    return this.modalService.hasOpenModals();
  }

  closeModal() {
    this.modalService.dismissAll();
    //console.log(this.modalService.hasOpenModals());
  }

  openErrorModal () {
    let  modalReference = this.modalService.open(InternalServerErrorModalComponent, { centered: true, keyboard: true, backdrop: true });
    modalReference.result.then((result) => {
      console.warn('Error Modal Loaded!!!!');
    }, (error) => {
      console.warn('Error while loading errorModal');
      this.modalService.dismissAll();
    });
  }

  openDataLostWarningModal () {
    let  modalReference = this.modalService.open(DataLostWarningModalComponent, { centered: false, keyboard: true, backdrop: 'static' });
    modalReference.result.then((result) => {
      return true;
    }, (error) => {
        this.modalService.dismissAll();
        return false;
    });

    return modalReference;
  }
}
